$('#bannerHome').slick({
  slidesToShow: 1,
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
});

$('#slickTeam').slick({
  dots: false,
  arrows: false, 
  adaptiveHeight: true,
  mobileFirst: true,
  autoplay: 5000,
  responsive: [
  {
    breakpoint: 760,
    settings: {
      dots: false,
      slidesToShow: 2,
    }
  },
  {
    breakpoint: 1020,
    settings: {
      slidesToShow: 4,
    }
  },
  {
    breakpoint: 1200,
    settings: {
      slidesToShow: 4,
      arrows: true,
      dots: false,
      prevArrow: '.backTeam',
      nextArrow: '.nextTeam'
    }
  },
  ]
});
